import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/themes/theme-provider';
import { AbilityProvider } from '@/auth/ability-provider';
import { router } from '@/router';
import { queryClient } from '@/api/query-client';
import { branding } from '@/config/branding';
import '@/index.css';
import '@/themes/global.css';

document.title = branding.name;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AbilityProvider>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </AbilityProvider>
    </QueryClientProvider>
  </StrictMode>,
);
